import { j as o } from "../../jsx-runtime-ClSzPYp4.js";
import s from "../BaseIcon.mjs";
const a = (c) => /* @__PURE__ */ o.jsx("svg", {
  "aria-label": "ASOS",
  viewBox: "0 0 699.05 699.05",
  enableBackground: "new 0 0 699.05 699.05",
  ...c,
  children: /* @__PURE__ */ o.jsx("path", {
    d: "M241.32,349.88c0-55.59,34.79-109.43,97.46-109.43s97.46,53.84,97.46,109.43   C436.24,497.04,241.32,497,241.32,349.88 M436.24,183.55v22.06c-29.76-20.9-62.04-30.66-96.97-30.84v-0.01   c-0.16,0-0.33,0.01-0.49,0.01c-0.17,0-0.33-0.01-0.49-0.01v0.01c-42.18,0.22-80.5,14.39-115.18,45.3   c-19.11,17.24-33.63,36.81-43.24,58.37c-9.52,21.47-14.41,45.53-14.41,71.4c0,24.16,4.3,46.8,12.74,67.28   c8.46,20.46,21.32,39.41,38.27,56.29c16.94,16.9,35.88,29.75,56.27,38.18c19.96,8.24,41.95,12.51,65.29,12.68v0.02   c0.25,0,0.49-0.01,0.74-0.01c0.25,0,0.49,0.01,0.74,0.01v-0.02c23.35-0.17,45.33-4.45,65.29-12.68   c10.92-4.51,21.42-10.31,31.43-17.3v21.2h72.86V183.55H436.24z"
  })
}), v = (c) => /* @__PURE__ */ o.jsx(s, {
  IconSvg: a,
  ...c
});
export {
  v as default
};
